import { useFormContext } from 'react-hook-form';
import { paymentFrequencyExtendedOptions } from '@@viewCommonComponents/forms/options';
import PropTypes from 'prop-types';
import { ControlledSelect } from '@@viewCommonComponents/controlled';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';

const ComAndFrequencyButtons = ({ rates, getMiddleBoolean, getMiddleText }) => {
  const form = useFormContext();
  const { watch } = form;

  const commissionRate = watch('packs.0.commission.rate');

  const defaultCommissionOptions = [
    {
      label: `${commissionRate} %`,
      value: commissionRate
    }
  ];

  return (
    <div className={'w-full flex flex-row mb-2 justify-end'}>
      <div className={'w-40'}>
        <ControlledSelect
          disabled={isNilOrEmpty(rates)}
          name={'packs.0.commission.rate'}
          form={form}
          rules={isRequiredSelect(rates || defaultCommissionOptions)}
          options={rates || defaultCommissionOptions}
          label={getMiddleText('PROCESSDEVENTE_TAUX_COMMISSION_LABEL')}
          data-testid="commissionRate"
        />
      </div>

      {getMiddleBoolean('DISPLAY_PAYMENT_FREQUENCY') && (
        <div className={'w-72'}>
          <ControlledSelect
            name="paymentInformations.paymentFrequency"
            form={form}
            rules={isRequiredSelect(paymentFrequencyExtendedOptions)}
            options={paymentFrequencyExtendedOptions}
            label={''}
            data-testid="paymentInformationsPaymentFrequency"
          />
        </div>
      )}
    </div>
  );
};

ComAndFrequencyButtons.propTypes = {
  setCommissionIsDisplay: PropTypes.func,
  commissionIsDisplay: PropTypes.bool,
  getIncreaseMensualPayment: PropTypes.object,
  rates: PropTypes.array
};

export default ComAndFrequencyButtons;
